module.exports = __webpack_public_path__ + "static/media/banner2.610a6dd9.jpg";